module.exports = __webpack_public_path__ + "static/pp_ulice-a06c9a1f083768f41456705f0e1b1714.gif";